import { httpGet, httpPost } from "../httpService/httpService";
import { AddGeometryProps, CheckReferenceLayersAvailabilityProps, GeometrySummary, NewUpdateGeometryProps } from "./types/geometryServiceProps";

const exampleSummary = {
    success: true,
    contours: [
        { name: "Tereny zagrożone", count: 4 },
        { name: "Osuwiska", count: 16 },
        { name: "Skarpy główne", count: 4 },
        { name: "Skarpy wtórne", count: 0 },
        { name: "Rowy", count: 0 },
        { name: "Granica osuwiska", count: 0 },
        { name: "Szczeliny", count: 0 },
        { name: "Strefa aktywności", count: 0 },
        { name: "Czoła", count: 0 },
        { name: "Wody punktowe", count: 0 },
        { name: "Wody powierzchniowe", count: 0 },
        { name: "Zagłębienia", count: 0 },
        { name: "Rumosze", count: 2 },
        { name: "Progi akumulacyjne", count: 2 }
    ],
    krs: [
        { name: "KRO 2020", count: 1 },
        { name: "KRTZ 2020", count: 2 },
        { name: "KRO 2007", count: 0 },
        { name: "KRTZ 2007", count: 0 }
    ],
    errors: [
        "Ładowanie geometrii zakończone niepowodzeniem",
        "OSUWISKO 123456",
        "OSUWISKO 112233"
    ]
} as GeometrySummary;

export const GetSummary = (jobId: string, apiUrl: string, apiVersion: string) => {
    return new Promise((resolve, reject) => {
        return httpPost(apiUrl + apiVersion + "/summary", {
            jobId: jobId
        }).then((res: any) => {
            resolve(exampleSummary);
        }).catch((error: any) => {
            //reject(error);
            resolve(exampleSummary);
        });
    })
}

export const addUpdateWaitingRoomGeometry = async (props: AddGeometryProps) => {

    const formData = new FormData();
    formData.append('UploadedFileGuid', props.uploadedFileGuid);
    formData.append('IsAdd', props.isAdd.toString());
    
    return new Promise((resolve, reject) => (
        httpPost(`${props.apiBase}/add-geometry`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    ));
}

export const updateGeometryDefault = async (props: NewUpdateGeometryProps) => {

    const formData = new FormData();
    formData.append('UploadedFileGuid', props.uploadedFileGuid);
    
    return new Promise((resolve, reject) => (
        httpPost(`${props.apiBase}/update-geometry-default`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    ));
}

export const newGeometry = async (props: NewUpdateGeometryProps) => {

    const formData = new FormData();
    formData.append('UploadedFileGuid', props.uploadedFileGuid);
    
    return new Promise((resolve, reject) => (
        httpPost(`${props.apiBase}/new-geometry`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    ));
}

export const checkReferenceLayersAvailability = async (props: CheckReferenceLayersAvailabilityProps) => {
    return new Promise((resolve, reject) => (
        httpGet(`${props.apiBase}/check-reference-layers`)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    ));
}